<template>
<div class="container singleIconCard">
    
        <div class="postCard">

                <div class="row d-inline-flex justify-content-around">
                    <div class="col">
                        <img :src="post.logo" class="logoicon">
                    </div>
                    <div class="col my-auto text-center text-light">
                        <h1>{{post.name}}</h1>
                    </div>
                </div>
            
            <div class="card-body">
                <h5 class="card-text firstDescription">{{post.description1}}</h5>
                
                <div class="row playImages d-flex justify-content-around">
                    <img class="playImg" :src="post.images[1].src">
                    <img class="playImg" :src="post.images[2].src">
                    <img class="playImg" :src="post.images[3].src">
                    <img class="playImg" :src="post.images[4].src">
                </div>

                <h5 class="card-text"><span v-html="post.description2"></span></h5>
            </div>

            <a :href="post.link" target="_blank" class="d-flex justify-content-start">
                <img class="playButton" :src="post.source" alt="">
            </a>

            <p><a class="btn btn-dark d-flex justify-content-center" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                    Show More
            </a></p>
            <div class="collapse" id="collapseExample">
                <div class="card-body">
                    <p class="card-text"><span v-html="post.description3"></span></p>
                </div>
            </div>

        </div>

</div>
</template>

<script>
import json from '../model/posts.json'

export default {
    data() {
        return {
            posts: json
        }
    },
    computed:{
        post(){
            var a = this.posts.filter(d => d.id === this.$route.params.id);
            return a[0]
        }
    }
}
</script>

<style>

.singleIconCard{
    max-width: 20cm;
}

.playButton{
    width: 150px;
    height: 100%;
    margin-bottom: 2vh;
}

.playImages{
    margin-top: 5vh;
    margin-bottom: 5vh;
}

.playImg{
    height: 310px;
    max-width: 100vw;
}

.appname{
    background-color: black;
}

.logoicon{
    border-radius:20%;
    height: 10vh;
}

.postCard{
    background-color: black;
    color: grey;
}


</style>